import React from 'react'
import './About.css'
import profilePic from '../../images/luciano.jpg'

export default function About() {
    return (
        <div className='about' id='about'>
            <div className='about_profilePic'>
                <img className='profile-pic' src={profilePic} alt='Luciano Galindez'></img>
            </div>
            <div className='about__info'>
                <div className='about__info-about'>
                    <h2>About me</h2>
                    <p>
                        My name is Luciano Galindez. I have a degree in Industrial Engineering from the National University of Tucuman. I am currently perfecting my skills as a Data Analyst. I also have good knowledge in the field of backend and frontend development with Javascript
                    </p>
                </div>
                <div className='about__info-contact'>
                    <h2>
                        Contact Details
                    </h2>
                    <ul>
                        <li>Luciano Galindez</li>
                        <li>San Martin 677</li>
                        <li>Tucuman, Argentina, 4000</li>
                        <li>+54 3813023087</li>
                        <li>lucianogalindez222@gmail.com</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
